import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "label-within-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.9195 11.4053C14.375 11.4053 14.7443 11.0361 14.7443 10.5806C14.7443 10.1251 14.375 9.7558 13.9195 9.7558C13.464 9.7558 13.0947 10.1251 13.0947 10.5806C13.0947 11.0361 13.464 11.4053 13.9195 11.4053Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.3745 7.24811L15.1646 7.24811C15.7182 7.24811 16.2491 7.46808 16.6405 7.85949C17.0319 8.25094 17.2517 8.78182 17.2517 9.33531V12.1247C17.251 12.6784 17.0305 13.21 16.6387 13.6011L13.0995 17.1406C12.2842 17.9554 10.9627 17.9556 10.1475 17.1408L7.3592 14.3532C6.54453 13.5378 6.54423 12.2163 7.3589 11.4009L10.8976 7.86187C11.2886 7.46985 11.8208 7.2488 12.3745 7.24811ZM15.1646 8.74811H12.375C12.2192 8.7484 12.0699 8.81056 11.9598 8.92093L8.42002 12.4611C8.19073 12.6908 8.19059 13.0631 8.42002 13.2927L11.2078 16.0798C11.4374 16.3092 11.8094 16.3092 12.039 16.0798L15.5789 12.5396C15.6892 12.4295 15.7514 12.2802 15.7517 12.1244V9.33531C15.7517 9.17953 15.6898 9.03019 15.5798 8.9201C15.4696 8.80996 15.3203 8.74811 15.1646 8.74811Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 8.5C2.25 5.28579 4.78579 2.75 8 2.75H16C19.2142 2.75 21.75 5.28579 21.75 8.5V16.5C21.75 19.6142 19.1142 22.25 16 22.25H8C4.78579 22.25 2.25 19.7142 2.25 16.5V8.5ZM8 4.25C5.61421 4.25 3.75 6.11421 3.75 8.5V16.5C3.75 18.8858 5.61421 20.75 8 20.75H16C18.2858 20.75 20.25 18.7858 20.25 16.5V8.5C20.25 6.11421 18.3858 4.25 16 4.25H8Z"
    }, null, -1)
  ])))
}
export default { render: render }